import React from "react";



import { Grid, Icon } from "@mui/material";
import { useTheme } from '@mui/material/styles';

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TelegramIcon from "@mui/icons-material/Telegram";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { useTranslation } from "react-i18next";
import enTranslations from "../../en.json";
import arTranslations from "../../ar.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    ar: { translation: arTranslations },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});


export default function SocialMedia() {
  const { t } = useTranslation();
    const theme = useTheme();
    const iconSize = Math.min(100, theme.breakpoints.values.sm / 10);

  return (
    <div className="container-media">
    <h1 className="title12">{t("follow")}</h1>
    <Grid container direction="row" sx={{gap: '1rem', padding: 1,flexWrap :"nowrap" }}>
      <Grid item xs={12} sm={6} md={3} sx={{display: 'flex', justifyContent: 'center'}}>
       <a href="https://www.facebook.com/financeBdariija/" target="_blank" rel="noreferrer"><Icon component={FacebookIcon} sx={{ fontSize: `${iconSize}px`, color: "#ffffff" }} /></a> 
      </Grid>
      <Grid item xs={12} sm={6} md={3} sx={{display: 'flex', justifyContent: 'center'}}>
      <a href="https://www.instagram.com/_financebdarija_/" target="_blank" rel="noreferrer"><Icon component={InstagramIcon} sx={{ fontSize: `${iconSize}px`, color: "#ffffff" }} /></a> 
      </Grid>
      <Grid item xs={12} sm={6} md={3} sx={{display: 'flex', justifyContent: 'center'}}>
      <a href="https://www.youtube.com/@Financebdarija" target="_blank" rel="noreferrer"> <Icon component={YouTubeIcon} sx={{ fontSize: `${iconSize}px`, color: "#ffffff"}} /></a> 
      </Grid>
      <Grid item xs={12} sm={6} md={3} sx={{display: 'flex', justifyContent: 'center'}}>
      <a href="https://t.me/Moroccan_Financial_show" target="_blank" rel="noreferrer"> <Icon component={TelegramIcon} sx={{ fontSize: `${iconSize}px`, color: "#ffffff" }} /></a> 
      </Grid>
    </Grid>
    </div>
  );
}
